const flickity = require('flickity-as-nav-for')
require('flickity-imagesloaded')
import PhotoSwipeLightbox from 'photoswipe/lightbox'
import PhotoSwipe from 'photoswipe'

export default class Product {
    constructor() {
        this.stickyCart = $('.product-sticky')
        this.carousel = document.querySelector('.product-hero__image__carousel')
        this.carouselInstance = null
        this.carouselSlide = '.product-hero__image__slide'
        this.thumbnails = document.querySelector('.product-hero__image__thumbnails')
        this.thumbnailInstance = null
        this.landingInstance = null
        this.landingCarousel = document.querySelector('.landing__hero_banner-container')
        this.productSubscription = $('.product__subscription')
        this.productSubscriptionCheckbox = $('.product__subscription__checkbox')
        this.productSubscriptionModalAccept = $('#product-subscription-term-accept')
        this.previewGallery = document.querySelector('#preview-gallery')
        this.galleryInstance = null
    }

    /**
     * Load flickity instance
     */
    startCarousel() {
        this.carouselInstance = new flickity(this.carousel, {
            accessibility: false,
            autoPlay: false,
            draggable: true,
            wrapAround: false,
            cellAlign: 'center',
            cellSelector: this.slide,
            prevNextButtons: true,
            pageDots: false,
            selectedAttraction: 0.2,
            friction: 0.8
        })
    }

    /**
     * Load thumbnail instance
     */
    startThumbnails() {
        this.thumbnailInstance = new flickity(this.thumbnails, {
            asNavFor: this.carousel,
            pageDots: false,
            prevNextButtons: false,
            contain: false,
            percentPosition: false,
            groupCells: "100%",
        })
    }

    /**
     * Load landing thumbnail instance
     */
    startLandingCarousel() {
        this.carouselInstance = new flickity(this.landingCarousel, {
            imagesLoaded: true,
            accessibility: false,
            autoPlay: 5000,
            draggable: true,
            wrapAround: true,
            cellAlign: 'center',
            prevNextButtons: true,
            pageDots: false,
            selectedAttraction: 0.2,
            friction: 0.8
        })
    }

    /**
     * Load gallery instance
     */
    startGallery() {
        this.galleryInstance = new PhotoSwipeLightbox({
            gallery: this.previewGallery,
            children: 'a',
            showHideAnimationType: 'none',
            pswpModule: PhotoSwipe
        })
        this.galleryInstance.init()
    }

    /**
     * Handle sticky behaviour of cart
     */
    handleSticky() {
        if ($(window).scrollTop() > 200) {
            this.stickyCart.addClass('is-visible')
        } else {
            this.stickyCart.removeClass('is-visible')
        }
    }

    /**
     * Control button position on mobile
     */
    setControlPosition() {
        let windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
        let imageHeight = $('.landing__hero_banner-container .right').height()
        if (windowWidth <= 640) {
            $('.landing__hero_banner-container .flickity-prev-next-button').css('top', imageHeight+45)
        } else {
            $('.landing__hero_banner-container .flickity-prev-next-button').css('top', '')
        }
    }

    /**
     * Accept product subscription
     */
    subscriptionAccept() {
        this.productSubscription.addClass('is-selected')
        this.productSubscriptionCheckbox.find('input').prop('checked', true)
        $('#modal-subscription .modal__close').trigger('click')
    }

    /**
     * Decline product subscription
     */
    subscriptionDecline() {
        if (this.productSubscription.hasClass('is-selected')) {
            this.productSubscription.removeClass('is-selected')
            this.productSubscriptionCheckbox.find('input').prop('checked', false)
        }
    }

    /**
     * Initialize class
     */
    init() {
        if (this.stickyCart) {
            $(window).on('scroll', () => this.handleSticky())
        }

        if (this.carousel && this.thumbnails) {
            this.startCarousel()
            this.startThumbnails()
        }

        if (this.landingCarousel) {
            this.startLandingCarousel()
            $(window).on('load resize', () => this.setControlPosition())
        }

        if (this.productSubscription.length) {
            this.productSubscriptionModalAccept.on('click', () => this.subscriptionAccept())
            this.productSubscriptionCheckbox.on('click', () => this.subscriptionDecline())
        }

        if (this.previewGallery) {
            this.startGallery()
        }
    }
}


